// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KjDB","index":"styles_index__1KArG"};